import { CollectionRepository, Id } from '../abstraction';
import { ReadonlyHttpCollectionRepository } from './readonly-http-collection.repository';
import { createHttpResourceLocation, HttpResourceLocation } from '../../data-access/types/http.location';
import { toIdString } from '../functions/to-id-string';
import { HttpDataAccess } from '../../data-access/http.data-access';
import { Dictionary } from '../../types/dictionary';
import { isDefined } from '../../functions/is-defined.function';

export abstract class HttpCollectionRepository<TItem, TResult, TCrudResult, TLoadParams = undefined, TCrudParams = undefined> extends ReadonlyHttpCollectionRepository<TResult, TLoadParams> implements CollectionRepository<TItem, TResult, TCrudResult, TLoadParams, TCrudParams> {

  protected constructor(dataAccess: HttpDataAccess,
                        url: string) {
    super(dataAccess, url);
  }

  create(value: TItem, params: TCrudParams): Promise<TCrudResult> {
    const location = this.createLocation(undefined, params);
    return this.dataAccess.create(location, value);
  }
  update(id: Id, value: TItem, params: TCrudParams): Promise<TCrudResult> {
    const location = this.createLocation(id, params);
    return this.dataAccess.update(location, value);
  }
  patch(id: Id, changes: Partial<TItem>, params: TCrudParams): Promise<TCrudResult> {
    const location = this.createLocation(id, params);
    return this.dataAccess.patch(location, changes);
  }
  delete(id: Id, params: TCrudParams): Promise<TCrudResult> {
    const location = this.createLocation(id, params);
    return this.dataAccess.delete(location);
  }

  private createLocation(id: Id | undefined, params: TCrudParams): HttpResourceLocation {
    let url = this.url;
    if(isDefined(id)) {
      url = `${url}/${toIdString(id)}`;
    }
    return createHttpResourceLocation({
      url: url,
      pathParams: this.getCRUDPathParams(params)
    });
  }

  protected abstract getCRUDPathParams(params: TCrudParams): Dictionary<unknown> | undefined;
}
